<template>
    <div class="repairability">
        <div class="picto">
            <div class="d-flex align-items-center">
                <img
                    class="align-self-center my-1"
                    alt=""
                    :src="picto.src"
                    :srcset="picto.srcSet"
                >
                <strong class="note" v-html="noteFormated(note)" />
                <a
                    class="ps-1"
                    :href="'#modal-repairability'"
                    data-bs-toggle="modal"
                    :aria-label="label + ' ' + noteFormated(note) + ' sur 10'"
                >
                    <strong v-html="label" />
                </a>
            </div>
        </div>
        <ob1-popin-modal2 :id="'modal-repairability'" :aria-labelledby="'modal-label-repairability'">
            <p :id="'modal-label-repairability'" class="h4" v-html="titlePopin" />
            <p v-html="textPopin" />
            <ob1-liens
                v-if="urlDocument"
                :with-arrow="true"
                :text="linkDocument"
                :href="urlDocument"
                :target="'_blank'"
            />
        </ob1-popin-modal2>
    </div>
</template>

<script>
export default {
    name: "Repairability",
    props: {
        picto: {
            type: Object,
            required: true
        },
        note: {
            type: Number,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        titlePopin: {
            type: String,
            required: true
        },
        textPopin: {
            type: String,
            required: true
        },
        linkDocument: {
            type: String,
            required: true
        },
        urlDocument: {
            type: String,
            required: true
        }
    },
    methods: {
        noteFormated(note) {
            return note.toString().replace(".", ",");
        }
    }
}
</script>
<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

@font-face {
    font-family: "Marianne Extra Bold";
    src: url("../../../../../front/fonts/Marianne-ExtraBold.woff2");
}

.picto {
    position: relative;
    width: 100%;

    & .note {
        position: absolute;
        left: px-to-rem(71);
        top: px-to-rem(15);
        width: px-to-rem(71);
        text-align: center;
        font-family: 'Marianne Extra Bold', sans-serif;
        font-size: px-to-rem(34);
        @media (min-width: #{map-get($grid-breakpoints, xl)}) {
            top: px-to-rem(13);
            font-size: px-to-rem(42);
        }
    }
}

@media (min-width: 736px) {
    .picto {
        width: px-to-rem(250);
    }
}

</style>
